// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cluster {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  background: #fff;\n  border: 6px solid;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n}\n\n.blue {\n  border-color: #1899ff;\n}\n\n.grey {\n  border-color: #b4b4b5;\n}\n", ""]);
// Exports
module.exports = exports;
